import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportConsistencyHistory } from '@api/consistencyCheckParameters';

import { TConsistencyCheckHistoryExportDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_CHECK_HISTORY_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyHistoryExport {
	exportConsistencyHistory: UseMutateFunction<any, any, TConsistencyCheckHistoryExportDTO, any>;
	isLoadingExportConsistencyHistory: boolean;
}

export const useMutateConsistencyHistoryExport = (): IUseMutateConsistencyHistoryExport => {
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConsistencyCheckHistoryExportDTO>({
		mutationKey: [CONSISTENCY_CHECK_HISTORY_EXPORT],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: exportConsistencyHistory,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.apiDocsExported,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportConsistencyHistory: mutate,
		isLoadingExportConsistencyHistory: isLoading,
	};
};
